import {ErrorState, ErrorStateDataHooks} from '../../../common/components/Layout/ErrorState/ErrorState';
import React from 'react';
import {useControllerProps} from '../Widget/ControllerContext';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {SPECS} from '../../../common/constants';
import {ChevronLeft} from '@wix/wix-ui-icons-common/on-stage';
import {Button} from 'wix-ui-tpa/cssVars';
import {classes} from './CheckoutErrorState.st.css';

export const CheckoutErrorState = () => {
  const {navigationStore, checkoutSettingsStore, isLoading} = useControllerProps();
  const localeKeys = useLocaleKeys();
  const {experiments} = useExperiments();

  if (experiments.enabled(SPECS.ShowErrorInCheckoutWhenNoPremium) && !isLoading && !checkoutSettingsStore?.isPremium) {
    return (
      <ErrorState
        title={localeKeys.checkout.paymentNotConnected.error.title()}
        subtitle={localeKeys.checkout.paymentNotConnected.error.message()}
        ctaButton={
          <Button
            as={'a'}
            data-hook={ErrorStateDataHooks.Button}
            href={navigationStore?.continueShoppingUrl}
            prefixIcon={<ChevronLeft />}
            className={classes.button}
            onClick={() => navigationStore?.clickOnContinueShopping()}>
            {localeKeys.checkout.currencyNotSupported.error.cta()}
          </Button>
        }
      />
    );
  }

  return <ErrorState onClick={navigationStore?.clickOnRefreshErrorState} />;
};
